import moment from 'moment';

const first = [
  {
    type: 'section',
    label: 'Technician & Date',
    labelAlign: 'center',
    style: 'blue',
    fields: [
      {
        name: 'STP6__2',
        label: 'Technician',
        required: true,
        validation: {
          page: 'SMF1',
          filter: {
            Status: 'Active',
          },
        },
      },
      {
        name: 'STP6__3',
        label: 'Date',
        type: 'date',
        required: true,
        inputProps: { showToday: true, showYesterday: true },
        data: moment().format('MM-DD-YYYY'),
      },
    ],
  },
];

const second = [
  {
    col: {
      md: 4,
      mdOffset: 4,
      lg: 4,
      lgOffset: 4,
    },
    name: 'STP6__50',
    label: '',
    type: 'string',
    displayOnly: true,
    data: [],
  },
  {
    type: 'table',
    label: 'Details',
    canInsert: true,
    fields: [
      {
        name: 'STP6__11',
        label: 'Start Time',
        type: 'time',
        required: true,
        maxLen: 5,
        noEmptyOption: true,
        autoPopulate: ['last'],
        data: [],
        events: {
          blur: {
            update: {
              method: {
                allKeys: true,
                name: 'dictlook',
              },
            },
          },
        },
      },
      {
        name: 'STP6__12',
        label: 'Start Date',
        type: 'date',
        required: true,
        noEmptyOption: true,
        autoPopulate: ['STP6__3', 'last'],
        data: [],
        events: {
          blur: {
            update: {
              method: {
                allKeys: true,
                name: 'dictlook',
              },
            },
          },
        },
      },
      {
        name: 'STP6__13',
        label: 'Work Code',
        type: 'string',
        required: true,
        noEmptyOption: true,
        options: [
          {
            value: 'WK',
            label: 'Work',
          },
          {
            value: 'OW',
            label: 'Off Work',
          },
          {
            value: 'BK',
            label: 'Break',
          },
          {
            value: 'ET',
            label: 'Early Time',
          },
        ],
        data: [],
        events: {
          blur: {
            update: {
              method: {
                allKeys: true,
                name: 'dictlook',
              },
            },
          },
        },
      },
      {
        name: 'STP6__14',
        label: 'Repair Order',
        type: 'string',
        width: 130,
        data: [],
        validation: {
          page: 'SMM4',
          sort: {
            field: 'Open Date',
            direction: 'desc',
          },
        },
      },
      {
        name: 'STP6__15',
        label: 'Operation',
        width: 70,
        type: 'integer',
        data: [],
      },
      {
        name: 'STP6__16',
        label: 'Start Time',
        type: 'number',
        precision: 1,
        readOnly: true,
        maxLen: 5,
        noEmptyOption: true,
        data: [],
      },
      {
        name: 'STP6__17',
        label: 'End Time',
        type: 'number',
        precision: 1,
        readOnly: true,
        maxLen: 5,
        noEmptyOption: true,
        data: [],
      },
      {
        name: 'STP6__18',
        label: 'Hours',
        type: 'number',
        precision: 1,
        readOnly: true,
        maxLen: 5,
        aggregate: {
          method: 'sumByCondition',
          params: ['STP6__18', 'STP6__13', '/^(?:WK)$/'],
        },
        noEmptyOption: true,
        data: [],
      },
      {
        name: 'STP6__19',
        label: 'Overtime',
        options: [
          {
            value: '1.5',
            label: '1.5',
          },
          {
            value: '2.0',
            label: '2.0',
          },
          {
            value: '2.5',
            label: '2.5',
          },
          {
            value: '3.0',
            label: '3.0',
          },
        ],
        data: [],
        helpText: 'Must be in #.# format.',
      },
      {
        name: 'STP6__20',
        label: 'Work Comp',
        width: 100,
        data: [],
      },
      {
        name: 'STP6__21',
        label: 'Original Line',
        hidden: true,
        data: [],
      },
      {
        name: 'STP6__22',
        label: 'Original Line',
        hidden: true,
        data: [],
      },
      {
        name: 'STP6__23',
        label: 'Original Line',
        hidden: true,
        data: [],
      },
      {
        name: 'STP6__24',
        label: 'Reason Code',
        data: [],
        options: [
          {
            value: 'SD',
            label: 'System Down',
          },
          {
            value: 'FR',
            label: 'Field Repair',
          },
          {
            value: 'PO',
            label: 'Technician Did Not Punch Out',
          },
          {
            value: 'PI',
            label: 'Technician Did Not Punch In',
          },
          {
            value: 'IP',
            label: 'Incorrect Punch',
          },
          {
            value: 'AT',
            label: 'Adjust Time',
          },
          {
            value: 'OA',
            label: 'Overtime Adjustment',
          },
          {
            value: 'OT',
            label: 'Other',
          },
        ],
      },
      {
        col: 3,
        name: 'STP6__25',
        label: 'Reason Description',
        data: [],
      },
    ],
  },
];

export default {
  first,
  second,
};
